import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Checkout.css';

export const CheckoutCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="checkout-page">
      <div className="checkout-container">
        <div className="checkout-card cancel">
          <div className="checkout-icon cancel-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>

          <h1>Pagamento Cancelado</h1>

          <p className="checkout-message">
            O processo de pagamento foi cancelado. Nenhuma cobrança foi realizada.
            Você pode tentar novamente quando quiser.
          </p>

          <div className="checkout-actions">
            <button
              className="btn btn-primary btn-lg"
              onClick={() => navigate('/settings')}
            >
              Voltar para Configurações
            </button>
            <button
              className="btn btn-outline"
              onClick={() => navigate('/dashboard')}
            >
              Ir para o Dashboard
            </button>
          </div>
        </div>

        <div className="checkout-help">
          <p>
            Teve algum problema? Entre em contato com nosso suporte em{' '}
            <a href="mailto:suporte@ghiconnect.com">suporte@ghiconnect.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};
